import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { OKTA_AUTH } from "@okta/okta-angular";
import type OktaAuth from "@okta/okta-auth-js";

/**
 * Root-path guard. When the URL is `/?username=foo@sevaro.com` we kick
 * off Okta sign-in immediately with `loginHint: foo@sevaro.com` so the
 * Okta login form lands with the email pre-filled. Without the query
 * param we just forward to `/admin` and let `OktaAuthGuard` drive the
 * normal redirect.
 *
 * The param name is `username` to match how the product's marketing /
 * email links have historically pointed at the app
 * (`.../?username=<user>`).
 */
export const loginHintGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const oktaAuth = inject<OktaAuth>(OKTA_AUTH);
  const username = route.queryParamMap.get("username")?.trim();

  if (username) {
    oktaAuth.signInWithRedirect({
      loginHint: username,
      originalUri: "/admin",
    }).catch(() => undefined);
    return false;
  }
  return router.createUrlTree(["/admin"]);
};
